import { FC, useCallback } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";
import { AllPossibleTopOpportunitiesOptionsType } from "@/components/pages/common/opportunities/utils/types/types";

export interface OpportunitiesTopOpportunitiesSelectProps {
  subject: string;
  topOpportunitiesOptions: Record<string, string>;
  groupBy: AllPossibleTopOpportunitiesOptionsType;
  setGroupBy(groupBy: AllPossibleTopOpportunitiesOptionsType): void;
}

export const TopOpportunitiesSelect: FC<
  OpportunitiesTopOpportunitiesSelectProps
> = ({ groupBy, setGroupBy, topOpportunitiesOptions, subject }) => {
  const changeHandler = useCallback(
    (event: SelectChangeEvent) => {
      setGroupBy(event.target.value as AllPossibleTopOpportunitiesOptionsType);
    },
    [setGroupBy],
  );

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="body2" color="text.secondary" whiteSpace="nowrap">
        Top {subject} by
      </Typography>

      <FormControl size="xsmall" sx={{ width: 100 }}>
        <Select value={groupBy} onChange={changeHandler}>
          {Object.entries(topOpportunitiesOptions).map(([value, label]) => {
            return (
              <MenuItem value={value} key={value}>
                {label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Stack>
  );
};
